import React from "react";
import '@fontsource/roboto/300.css';
import PaginaCadastro from "../../CadastroUsuario/CadastroUsuario";
import Rodape from '../../Rodape/Rodape';
import NavBar from '../../NavBar_Top/NavBar_Top';

function cadastroUsuario() {   
    return (
       <>
          <NavBar/>
            <PaginaCadastro />
          <Rodape />  
       </>
    )
}
export default cadastroUsuario;
